<template>
  <div
    v-if="uiStore.isSplashScreenVisible"
    class="splash-screen"
    :class="{ fadeout: !isShowing }"
  >
    <video
      src="@/assets/videos/Celsetia_RPG_Intro.mp4"
      autoplay
      muted
      playsinline
      @ended="handleVideoEnd"
      @error="handleVideoEnd"
    ></video>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { useUiStore } from "../store/ui";

const uiStore = useUiStore();
const isShowing = ref(true);
let dismissed = false;
let fallbackTimer = null;

const handleVideoEnd = () => {
  if (dismissed) return;
  dismissed = true;
  if (fallbackTimer) {
    clearTimeout(fallbackTimer);
    fallbackTimer = null;
  }
  isShowing.value = false;
  setTimeout(() => {
    uiStore.hideSplashScreen();
  }, 1500);
};

onMounted(() => {
  fallbackTimer = setTimeout(handleVideoEnd, 8000);
});

onUnmounted(() => {
  if (fallbackTimer) {
    clearTimeout(fallbackTimer);
    fallbackTimer = null;
  }
});
</script>

<style scoped>
.splash-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  opacity: 1;
  transition: opacity 0.5s ease-out; /* Fade-out transition */
}

.splash-screen.fadeout {
  opacity: 0;
}

video {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensures video covers the screen without distortion */
}
</style>
